import { render, staticRenderFns } from "./RenderTotalGrade.vue?vue&type=template&id=12f3b58e"
import script from "./RenderTotalGrade.vue?vue&type=script&lang=js"
export * from "./RenderTotalGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports